import React, { Component } from 'react'
import { useAdvancedFilters } from '../../Filters/filterUrl'
import { Table, UncontrolledTooltip } from 'reactstrap'
import moment from 'moment'
import PrimaryListingContainer from "../../Material/PrimaryListingContainer"
import gql from 'graphql-tag'
import { graphql } from '@apollo/client/react/hoc'
import withApolloClient from '../../withApolloClient'
import CreateUpdateTPAConfigModal from '../Modals/CreateUpdateTPAConfigModal'
import DatetimeRenderer from '../../Material/DatetimeRenderer'
import HistoryListModal from '../../Material/HistoryListModal'

const AllTPAConfigsQuery = gql`
query AllTPAConfigs($orderBy: [String], $first:Int!, $cursor:String, $searchTerm:String, $filters: [FilterInput]) {
  allTpaConfigs(orderBy: $orderBy, first: $first, after: $cursor, searchTerm: $searchTerm, filters: $filters) {
    edges {
      node {
        id
        pk
        dateAdded
        dateModified
        claimType
        startDate
        endDate
        communicationChannel
        tpa{
            id
            name
        }
        lineOfBusiness {
          id
          name
          branchSet {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  tpaConfigCommunicationChannelChoices: __type(name: "IncidentsTPAConfigCommunicationChannelChoices") {
    enumValues {
      name
      description
    }
  }
  tpaConfigClaimTypeChoices: __type(name: "IncidentsTPAConfigClaimTypeChoices") {
    enumValues {
      name
      description
    }
  }
  tpaConfigNodeFieldDescriptions: __type(name: "TPAConfigNode") {
    fields {
      name
      description
    }
  }
}
`

class TPAConfigList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: null,
        }
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }

    render() {
        const fieldDescriptions = this.props.tpaConfigNodeFieldDescriptions?.fields.reduce((acc, field) => {
            acc[field.name] = field.description
            return acc
        }, {})

        return (
            <PrimaryListingContainer
                listLoading={this.props.loading}
                loadMoreEntries={this.props.allTpaConfigs?.pageInfo?.hasNextPage ? this.props.loadMoreEntries : null}
                refetchListQuery={this.props.refetchQuery}
            >
                <Table responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th className='actions-th'>Actions</th>
                            {this.props.columnConfig?.filter(col => col?.preferenceSettings?.isVisible).map((column, index) => (
                                column.sortable ?
                                    <th key={column.id} onClick={() => this.props.updateOrder(column.id)} style={{ cursor: "pointer" }}>
                                        {this.props.orderBy.some(order => order.includes(column.id)) ?
                                            <i className={"fa " + (this.props.orderBy.includes(column.id) ? 'fa-sort-asc' : 'fa-sort-desc')}></i>
                                            : <i className='fa fa-sort'></i>
                                        }
                                        &nbsp;&nbsp;{column.name}
                                    </th>
                                    :
                                    <th key={column.id}>
                                        {column.name}
                                        {fieldDescriptions && fieldDescriptions.hasOwnProperty(column.id) && fieldDescriptions[column.id] && (
                                            <>
                                                <i className="fa fa-info-circle ml-1" style={{ fontSize: "12px" }} id={"infoCircle" + column.id} />
                                                <UncontrolledTooltip target={"infoCircle" + column.id} placement="bottom">{fieldDescriptions[column.id]}</UncontrolledTooltip>
                                            </>
                                        )}
                                    </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.allTpaConfigs?.edges?.length > 0 ? this.props.allTpaConfigs.edges.map((config, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td className='actions-td'>
                                    <span className='action-item'>
                                        <i className="fa fa-edit" title="Edit TPA Config" style={{ cursor: "pointer" }} onClick={() => this.setState({ openModal: "editTpaConfig" + i })}></i>
                                        {this.state.openModal === "editTpaConfig" + i &&
                                            <CreateUpdateTPAConfigModal
                                                isOpen={this.state.openModal === "editTpaConfig" + i}
                                                toggle={() => this.setState({ openModal: "" })}
                                                id={config.node.id}
                                                refetchQuery={this.props.refetchQuery}
                                            />
                                        }
                                    </span>
                                    <span className='action-item'>
                                        <i className='fa fa-history' id={`viewHistory${config.node.pk}`} aria-hidden="true" style={{ cursor: "pointer" }} onClick={() => this.toggleModal(`viewHistory${config.node.pk}`)}></i>
                                        {this.state.openModal === `viewHistory${config.node.pk}` &&
                                            <HistoryListModal
                                                isOpen={this.state.openModal === `viewHistory${config.node.pk}`}
                                                toggle={() => this.toggleModal("")}
                                                title={`Change History Of Item ${i + 1}`}
                                                objectIds={[config.node.id]}
                                                emptyText="No history available."
                                            />
                                        }
                                    </span>
                                </td>
                                {this.props.columnConfig?.filter(column => column?.preferenceSettings?.isVisible).map(column => <>
                                    {column.id === "date_added" && <td>{config.node.dateAdded ? <DatetimeRenderer datetime={config.node.dateAdded} /> : <span className="null-val-color">N/A</span>}</td>}
                                    {column.id === "date_modified" && <td>{config.node.dateModified ? <DatetimeRenderer datetime={config.node.dateModified} /> : <span className="null-val-color">N/A</span>}</td>}
                                    {column.id === "tpa" && <td>{config.node.tpa?.name || <span className="null-val-color">N/A</span>}</td>}
                                    {column.id === "claimType" && <td>{this.props.tpaConfigClaimTypeChoices?.enumValues.find(item => item.name === config.node.claimType)?.description || config.node.claimType}</td>}
                                    {column.id === "communicationChannel" && <td>{this.props.tpaConfigCommunicationChannelChoices?.enumValues.find(item => item.name === config.node.communicationChannel)?.description || config.node.communicationChannel}</td>}
                                    {column.id === "startDate" && <td>{config.node.startDate ? moment(config.node.startDate).format("MM/DD/YYYY") : <span className="null-val-color">N/A</span>}</td>}
                                    {column.id === "endDate" && <td>{config.node.endDate ? moment(config.node.endDate).format("MM/DD/YYYY") : <span className="null-val-color">N/A</span>}</td>}
                                    {column.id === "lineOfBusiness" && <td>{config.node.lineOfBusiness?.name || <span className="null-val-color">N/A</span>}</td>}
                                    {column.id === "branches" && <td>
                                        {config.node.lineOfBusiness?.branchSet?.edges.map(({ node }, idx) => (
                                            <span key={node.id}>{node.name}{idx < config.node.lineOfBusiness.branchSet.edges.length - 1 ? ', ' : ''}</span>
                                        ))}
                                    </td>}
                                </>)}
                            </tr>
                        )) : !this.props.loading && (
                            <tr>
                                <td colSpan={this.props.columnConfig?.length + 2}>No TPA Configs found!</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </PrimaryListingContainer>
        )
    }
}

const TPAConfigListWithData = graphql(AllTPAConfigsQuery, {
    options: ({ searchTerm, orderBy, filters }) => ({
        variables: { first: 30, searchTerm, orderBy, filters },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, allTpaConfigs, fetchMore, variables, tpaConfigCommunicationChannelChoices, tpaConfigClaimTypeChoices, tpaConfigNodeFieldDescriptions } }) => ({
        loading,
        allTpaConfigs,
        variables,
        tpaConfigCommunicationChannelChoices,
        tpaConfigClaimTypeChoices,
        tpaConfigNodeFieldDescriptions,
        refetchQuery: () => {
            let currentLength = allTpaConfigs && allTpaConfigs.edges ? allTpaConfigs.edges.length : 30
            return fetchMore({
                query: AllTPAConfigsQuery,
                variables: {
                    ...variables,
                    first: currentLength,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allTpaConfigs.edges
                    const pageInfo = fetchMoreResult.allTpaConfigs.pageInfo
                    return {
                        allTpaConfigs: {
                            edges: [...newEdges],
                            pageInfo,
                            __typename: previousResult.allTpaConfigs.__typename
                        },
                    }
                },
            })
        },
        loadMoreEntries: () => {
            return fetchMore({
                query: AllTPAConfigsQuery,
                variables: {
                    cursor: allTpaConfigs.pageInfo.endCursor,
                    ...variables
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allTpaConfigs.edges
                    const pageInfo = fetchMoreResult.allTpaConfigs.pageInfo
                    return {
                        allTpaConfigs: {
                            edges: [...previousResult.allTpaConfigs.edges, ...newEdges],
                            pageInfo,
                            __typename: previousResult.allTpaConfigs.__typename
                        },
                    }
                },
            })
        },
    })
})(withApolloClient(TPAConfigList))

// Advanced filters live in the URL; feed them as the single `filters` variable.
export default function TPAConfigListWithFilters(props) {
    const [advancedFilters] = useAdvancedFilters()
    return <TPAConfigListWithData {...props} filters={advancedFilters} />
}
